import { controlToastState } from "risa-oasis-ui_v2";
import {
  pushFilesToSftp,
  PushToSftpResponse,
} from "../../../../api/postCall/pushToSftp";
import { ModalId } from "../../../../enums/modalId";
import { SftpPushPendingRecordsTableColumnKeys } from "../../../../enums/tableColumnKeys";
import { setOpenedModalId } from "../../../../redux/slice/modalSliceNew";
import { AppDispatch } from "../../../../redux/store/store";
import { SftpPushPendingRecordsTableDataModel } from "../hooks/useSftpPushPending";

export const onPushToSftp = async (
  tableData: SftpPushPendingRecordsTableDataModel[],
  dispatch: AppDispatch,
  setTableData: (data: SftpPushPendingRecordsTableDataModel[]) => void,
): Promise<PushToSftpResponse | null> => {
  const selectedData = tableData.filter(
    (item) => item[SftpPushPendingRecordsTableColumnKeys.SELECT]?.isChecked,
  );

  if (selectedData.length === 0) {
    controlToastState("push-to-sftp-no-selection");
    return null;
  }

  const selectedFilenames = selectedData
    .map((item) => item[SftpPushPendingRecordsTableColumnKeys.FILENAME])
    .filter((filename): filename is string => filename !== undefined);

  if (selectedFilenames.length === 0) {
    controlToastState("push-to-sftp-no-selection");
    return null;
  }

  try {
    // Pass onlyResubmit: true for pending records push
    const response = await pushFilesToSftp(selectedFilenames, {
      onlyResubmit: true,
    });

    // Close the modal and reset table data
    setTableData([]);

    dispatch(
      setOpenedModalId({
        id: ModalId.SFTP_STATUS_MODAL,
        metaData: {
          sftpResponse: response,
        },
      }),
    );

    return response;
  } catch (error) {
    console.error("Error pushing files to SFTP:", error);
    controlToastState("push-to-sftp-failure");
    return null;
  }
};
